import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = {
    max: Number,
    atLimitMessage: String,
    belowLimitMessage: String,
  }

  connect() {
    // Seed the initial state without announcing it — the announcement is for
    // changes the user makes, not for the page loading.
    this.wasAtLimit = this.render()
  }

  update() {
    const atLimit = this.render()

    if (atLimit !== this.wasAtLimit) {
      this.announce(
        atLimit ? this.atLimitMessageValue : this.belowLimitMessageValue,
      )
      this.wasAtLimit = atLimit
    }
  }

  // Disable the unchecked boxes once the cap is reached; returns whether it is.
  render() {
    const checkboxes = this.checkboxes
    const atLimit =
      checkboxes.filter((box) => box.checked).length >= this.maxValue

    for (const box of checkboxes) {
      box.disabled = atLimit && !box.checked
    }

    return atLimit
  }

  announce(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }

  get checkboxes() {
    return Array.from(this.element.querySelectorAll("input[type='checkbox']"))
  }
}
